import React from 'react';

const Header = ({ currentStep, totalSteps, isSubmitted }) => {
  const progressPercent = totalSteps > 0 ? Math.round(((currentStep + 1) / totalSteps) * 100) : 0;

  return (
    <header className="w-full bg-white shadow-sm py-5 px-4 sticky top-0 z-50 border-b border-slate-100">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
        
        {/* Logo Adium Header - 2x más grande */}
        <div className="flex items-center justify-center sm:justify-start">
          <img
            src="https://ftp.pcnpublicidad.com/adium/logo.png"
            alt="Adium Logo"
            className="h-20 sm:h-24 w-auto object-contain transition-all duration-300"
          />
        </div>

        {/* Barra de avance en Rojo */}
        {!isSubmitted && totalSteps > 0 && (
          <div className="flex flex-col items-center sm:items-end w-full sm:w-72">
            <span className="text-xs font-bold uppercase tracking-wider text-slate-600 mb-1.5">
              Pregunta {currentStep + 1} de {totalSteps} ({progressPercent}%)
            </span>
            <div className="w-full bg-slate-100 h-3.5 rounded-full overflow-hidden border border-slate-200 shadow-inner">
              <div
                className="bg-gradient-to-r from-red-500 to-adium-red h-full transition-all duration-400 ease-out rounded-full shadow-sm"
                style={{ width: `${progressPercent}%` }}
              />
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
